module.exports = __webpack_public_path__ + "img/Wu_Brandon.6e68d3c4.png";